<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p>{{ $t('notification.text.showNotification.adas') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack href="/notification" />
        </div>
      </div>
    </div>
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :activeFilters="activeFilters"
      :hasCheckbox="false"
      :hasFilter="true"
      searchable
      withCard
      :refreshData="!falseAlertSubmit"
    >
      <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
        <McFilterSelect
          :defaultColumnOrder="initialFields"
          :currentColumnOrder="dataFields"
          @setColumn="handleSetDataFields"
          @setField="handleFieldShow"
        />
      </template>
      <template #button-filter>
        <div class="d-flex justify-content-end">
          <div class="mc-table-filter me-2">
            <date-picker
              ref="notifPeriodPicker"
              v-model="period"
              placeholder="Pilih Tanggal"
              value-type="YYYY-MM-DD"
              format="DD MMM YYYY"
              :shortcuts="makeShortcuts"
              :clearable="false"
              range-separator=" - "
              range
              :confirm="true"
              :confirm-text="$t('global.action.apply')"
              :disabled-date="disabledRange"
              :lang="datePickerLang"
              @input="changeDate"
              @pick="pickDate"
              @close="closePicker"
            >
              <template #footer>
                <McButton
                  class="me-2"
                  variant="outline-primary"
                  :text="$t('global.action.cancel')"
                  @click="closeCalendar()"
                />
              </template>
            </date-picker>
          </div>
          <ModalFilter
            :activeFilters="filterModal"
            :alertCode="alertsFilter"
            :selectedPeriod="period"
            @applyFilters="handleApplyFilters"
          />
        </div>
      </template>
      <template #cell(alert)="data">
        <div class="text-primary clickable-field" @click="openModalNotification(data.item)">
          {{ $i18n.locale == 'id' ? data.value.descriptionIdn : data.value.descriptionEng }}
        </div>
      </template>
      <template #cell(createdOn)="data">
        <div class="d-flex flex-column">
          <span>{{ momentDateShortMonth(data.item.createdOn) }}</span>
          <span class="text-muted">{{ momentTimeSeconds(data.item.createdOn) }}</span>
        </div>
      </template>
      <template #cell(vehicle)="data">
        {{ data.value.licensePlate ?? '-' }}
      </template>
      <template #cell(geofence)>
        -
      </template>
      <template #cell(address)="data">
        <b-skeleton v-if="getAddress(data) === undefined" width="70%" />
        <span v-else>{{ getAddress(data) }}</span>
      </template>
      <template #cell(falseAlert)="data">
        <span v-if="data.item.lastUserFeedback?.isFalseAlert" class="false-alert-icon">
          <i class="mc-fa icon-fill_checkmark-circle"></i>
        </span>
        <span v-else>{{ '-' }}</span>
      </template>
      <template #cell(falseAlertReason)="data">
        {{ data.item.lastUserFeedback?.isFalseAlert ? data.item.lastUserFeedback?.feedback : '-' }}
      </template>
      <template #cell(video)="data">
        <button
          v-if="
            getStatusVideo(data.item) == 'uploaded' ||
            data.item.additionalData?.downloadVideoStatus === 'S' ||
            isSuccessRequestVideo(data.item.vehicle.id, data.item.createdOn)
          "
          class="mc-btn--play"
          @click="openVideo(data.item)"
        >
          <i class="mc-fa icon-outline_play-circle" />
          <span class="label-btn">{{ $t('global.media') }}</span>
        </button>
        <span
          v-if="
            getStatusVideo(data.item) == 'pending' ||
            isLoadingRequestVideo(data.item.vehicle.id, data.item.createdOn) ||
            isRequestInProgress(data.item.vehicle.id, data.item.createdOn) ||
            data.item.additionalData?.downloadVideoStatus === 'I'
          "
          class="mc-status mc-status--blue"
        >
          {{ $t('global.action.uploadProcess') }}
        </span>
        <span
          v-if="
            (getStatusVideo(data.item) == 'failed' && isMoreThan3Days(data.item.createdOn)) ||
            data.item.additionalData?.downloadVideoStatus === 'F' ||
            isFailedRequestVideo(data.item.vehicle.id, data.item.createdOn)
          "
          class="mc-status mc-status--red"
        >
          {{ $t('global.action.notAvailable') }}
        </span>
        <button
          v-if="
            getStatusVideo(data.item) == 'failed' &&
            !isMoreThan3Days(data.item.createdOn) &&
            !isLoadingRequestVideo(data.item.vehicle.id, data.item.createdOn) &&
            !isFailedRequestVideo(data.item.vehicle.id, data.item.createdOn) &&
            !isRequestInProgress(data.item.vehicle.id, data.item.createdOn) &&
            !isSuccessRequestVideo(data.item.vehicle.id, data.item.createdOn) &&
            data.item.additionalData === null &&
            data.item.additionalData?.downloadVideoStatus !== 'F' &&
            data.item.additionalData?.downloadVideoStatus !== 'I' &&
            data.item.additionalData?.downloadVideoStatus !== 'S'
          "
          v-b-tooltip.hover
          class="mc-btn--rerequest btn"
          :class="{
            disabled: isLoadingCheckDeviceOffline(data.item.vehicle.id, data.item.createdOn),
          }"
          :title="$t('notification.text.failedAutoUploadMedia')"
          @click="handleClickRequestVideo(data.item)"
        >
          <b-spinner
            v-if="isLoadingCheckDeviceOffline(data.item.vehicle.id, data.item.createdOn)"
          />
          <i v-else class="mc-fa icon-outline_download"></i>
          <span class="label-btn">
            {{ $t('notification.text.requestMedia') }}
          </span>
        </button>
      </template>
    </McGrapqlTable>
    <b-modal
      id="modal-notification"
      scrollable
      hide-footer
      size="lg"
      centered
      @hide="closeModalNotification"
    >
      <template #modal-header="{ close }">
        <span>
          {{ detailNotification.vehicle ? detailNotification.vehicle.licensePlate : '' }}
          -
          {{
            detailNotification.driver
              ? detailNotification.driver.fullname
              : $t('global.text.noDriver')
          }}
        </span>
        <i class="icon-outline_close" @click="close()" />
      </template>
      <div class="mc-modal-fleet mc-modal-fleet--notification">
        <div class="mc-modal-fleet__item">
          <div>
            <div
              class="mc-modal-fleet__item-status mc-modal-fleet__item-status--notif clearfix mb-3 mt-0"
            >
              <h4 class="text-pink float-start">
                {{
                  detailNotification.alert
                    ? $i18n.locale === 'id'
                      ? detailNotification.alert.descriptionIdn
                      : detailNotification.alert.descriptionEng
                    : '-'
                }}
              </h4>
              <div class="float-end text-end">
                <b-button
                  title="Lihat Video"
                  class="float-end ms-2"
                  variant="primary"
                  :disabled="getStatusUpload != 'uploaded'"
                  @click="openVideo(detailNotification)"
                >
                  <i class="mc-fa icon-fill_video" />
                  {{ $t('global.media') }}
                </b-button>
                <button
                  type="button"
                  class="btn float-end btn-outline-primary"
                  disabled
                  :title="$t('notification.action.callDriver')"
                >
                  <i class="mc-fa icon-outline_phone" />
                  {{ $t('notification.action.callDriver') }}
                </button>
              </div>
            </div>
            <dl class="mc-modal-fleet__item-list clearfix pb-0">
              <dt v-if="getStatusUpload != 'uploaded'">
                {{ $t('liveView.text.videoStatus') }}
              </dt>
              <dd v-if="getStatusUpload != 'uploaded'">
                <span v-if="getStatusUpload == 'pending'" class="mc-status mc-status--blue">{{
                  $t('global.action.uploadProcess')
                }}</span>
                <span v-if="getStatusUpload == 'failed'" class="mc-status mc-status--red">{{
                  $t('global.action.notAvailable')
                }}</span>
              </dd>
              <dt>{{ $t('global.time.time') }}</dt>
              <dd>
                {{ momentDateShortMonth(detailNotification.createdOn) }} -
                {{ momentTimeSeconds(detailNotification.createdOn) }}
              </dd>
              <dt>{{ $t('global.object.location') }}</dt>
              <dd>{{ detailNotification.address }}</dd>
            </dl>
            <div class="mc-modal-fleet__item-false">
              <div class="d-flex align-items-center">
                <i class="mc-fa icon-fill_bell-off"></i>
                <span class="ms-2">
                  <template v-if="detailNotification?.isFalseAlert">
                    {{ $t('notification.text.falseAlert') }}
                    <strong>{{ detailNotification.lastUserFeedback?.feedback }}</strong>
                  </template>
                  <template v-else>
                    {{ $t('notification.text.isFalseAlert') }}
                  </template>
                </span>
                <div class="ms-auto">
                  <template v-if="formOpen">
                    <McButton
                      :text="$t('global.action.cancel')"
                      variant="secondary"
                      size="sm"
                      class="me-2"
                      @click="formOpen = false"
                    />
                    <McButton
                      :text="$t('global.action.save')"
                      variant="primary"
                      size="sm"
                      @click="saveFalseAlert(true)"
                    />
                  </template>
                  <template v-else>
                    <McButton
                      v-if="detailNotification?.isFalseAlert"
                      :text="`${$t('global.alert.text.cancel')} False Alert`"
                      variant="secondary"
                      size="sm"
                      class="me-2"
                      @click="saveFalseAlert(false)"
                    />
                    <McButton
                      :text="
                        detailNotification?.isFalseAlert
                          ? $t('global.action.change')
                          : $t('notification.text.markFalseAlert')
                      "
                      variant="secondary"
                      size="sm"
                      @click="formOpen = true"
                    />
                  </template>
                </div>
              </div>
              <div v-if="formOpen" class="col-md-6 mt-2">
                <label>
                  {{ $t('notification.text.falseAlertReason') }}
                  <span class="text-danger">*</span>
                </label>
                <FormulateForm v-model="falseAlertForm">
                  <template v-for="reason in falseAlertReasons">
                    <McRadioButton
                      :id="reason.key"
                      :key="reason.key"
                      v-model="falseAlertForm.reason"
                      name="reason"
                      :initialValue="reason.key"
                      :label="`${reason.label}`"
                      class="mb-1"
                    />
                  </template>
                  <FormulateInput
                    v-model="falseAlertForm.others"
                    type="textarea"
                    name="others"
                    :placeholder="$t('notification.text.giveOtherReasons')"
                    :validation="
                      falseAlertForm.reason === 'others'
                        ? 'required|max:300,length'
                        : 'max:300,length'
                    "
                    :validation-name="$t('notification.text.otherReasons')"
                    error-behavior="live"
                    :disabled="falseAlertForm.reason !== 'others'"
                  />
                </FormulateForm>
              </div>
            </div>
          </div>
        </div>
        <h4
          class="mc-sidebar-liveview__list-notif-more d-block btn btn-outline-primary mt-3 mc-notif-open"
          @click="onClicked(detailNotification)"
        >
          <span class="mc-notif-open-text">
            <i class="mc-fa icon-outline_map" /> {{ $t('global.action.seeDetail') }}
          </span>
        </h4>
      </div>
    </b-modal>
    <b-modal
      id="modal-video"
      ref="modal-video"
      :title="`${$t('notification.object.notificationMedia')} - ${
        $i18n.locale === 'id' ? dataVideo?.alert?.descriptionIdn : dataVideo?.alert?.descriptionEng
      }`"
      size="xl"
      centered
      :modal-class="`mc-modal-video ${
        !isFullScreen ? 'mc-modal-video--liveview' : 'mc-modal-video--liveview-full'
      }`"
      @hide="hideModalVideo"
    >
      <div class="mc-modal-video__Wrapper">
        <div class="mc-modal-video__top">
          <b-row>
            <b-col md="3">
              <div>
                <span class="d-block text-muted">{{ $t('global.object.licensePlate') }}</span>
                <div>
                  <strong>{{ dataVideo.vehicle ? dataVideo.vehicle.licensePlate : '-' }}</strong>
                  <b-badge class="bg-success" :title="$t('liveView.filter.moving')">
                    {{ $t('liveView.filter.moving') }}
                  </b-badge>
                </div>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.fleetCategory') }}</span>
                <strong>{{
                  dataVideo.vehicle
                    ? dataVideo.vehicle.vehicleType
                      ? dataVideo.vehicle.vehicleType.category
                      : '-'
                    : '-'
                }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.driver') }}</span>
                <strong>{{ dataVideo.driver ? dataVideo.driver.fullname : '-' }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.phoneNumber') }} GPS</span>
                <strong>{{
                  dataVideo.vehicle
                    ? dataVideo.vehicle.device
                      ? dataVideo.vehicle.device.phoneNo
                      : '-'
                    : '-'
                }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">IMEI</span>
                <strong>{{ dataVideo.vehicle ? dataVideo.vehicle.imei : '-' }}</strong>
              </div>
            </b-col>
          </b-row>
          <div class="mc-modal-fleet__item-false mt-3">
            <div class="d-flex align-items-center">
              <i class="mc-fa icon-fill_bell-off"></i>
              <span class="ms-2">
                <template v-if="dataVideo?.isFalseAlert">
                  {{ $t('notification.text.falseAlert') }}
                  <strong>{{ dataVideo.lastUserFeedback?.feedback }}</strong>
                </template>
                <template v-else>
                  {{ $t('notification.text.isFalseAlert') }}
                </template>
              </span>
              <div class="ms-auto">
                <template v-if="formOpen">
                  <McButton
                    :text="$t('global.action.cancel')"
                    variant="secondary"
                    size="sm"
                    class="me-2"
                    @click="formOpen = false"
                  />
                  <McButton
                    :text="$t('global.action.save')"
                    variant="primary"
                    size="sm"
                    @click="saveFalseAlert(true)"
                  />
                </template>
                <template v-else>
                  <McButton
                    v-if="dataVideo?.isFalseAlert"
                    :text="`${$t('global.alert.text.cancel')} False Alert`"
                    variant="secondary"
                    size="sm"
                    class="me-2"
                    @click="saveFalseAlert(false)"
                  />
                  <McButton
                    :text="
                      dataVideo?.isFalseAlert
                        ? $t('global.action.change')
                        : $t('notification.text.markFalseAlert')
                    "
                    variant="secondary"
                    size="sm"
                    @click="formOpen = true"
                  />
                </template>
              </div>
            </div>
            <div v-if="formOpen" class="col-md-6 mt-2">
              <label>
                {{ $t('notification.text.falseAlertReason') }}
                <span class="text-danger">*</span>
              </label>
              <FormulateForm v-model="falseAlertForm">
                <template v-for="reason in falseAlertReasons">
                  <McRadioButton
                    :id="reason.key"
                    :key="reason.key"
                    v-model="falseAlertForm.reason"
                    name="reason"
                    :initialValue="reason.key"
                    :label="`${reason.label}`"
                    class="mb-1"
                  />
                </template>
                <FormulateInput
                  v-model="falseAlertForm.others"
                  type="textarea"
                  name="others"
                  :placeholder="$t('notification.text.giveOtherReasons')"
                  validation="max:300,length"
                  :validation-name="$t('notification.text.otherReasons')"
                  error-behavior="live"
                  :disabled="falseAlertForm.reason !== 'others'"
                />
              </FormulateForm>
            </div>
          </div>
        </div>
        <div class="mc-modal-video__content">
          <div
            class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
          >
            <div class="mc-trackvideo-list__item-video-content-open-source">
              <video-player
                v-if="getFormatVideo === 'mp4'"
                ref="videoInPlayerNotif"
                class="vjs-custom-skin"
                :options="playerInOptions"
                @ready="onInPlayerReady($event)"
                @error="onInPlayerError($event)"
                @waiting="onInPlayerWaiting($event)"
                @loadeddata="onInPlayerLoadedData($event)"
                @ended="onInPlayerEnded($event)"
              />
              <video-player-mux
                v-else-if="getFormatVideo === 'ts'"
                ref="videoInPlayerNotif"
                class="vjs-custom-skin"
                :src="dataVideo.formattedAlertData"
                :playerId="`videoPlayer${dataVideo.vehicleId}`"
                @ready="onInPlayerReady($event)"
                @error="onInPlayerError($event)"
                @waiting="onInPlayerWaiting($event)"
                @loadeddata="onInPlayerLoadedData($event)"
                @ended="onInPlayerEnded($event)"
              />
            </div>
            <div
              class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action"
            >
              <div>
                <span>
                  <i
                    v-if="!isPlay"
                    class="mc-fa icon-outline_play-circle"
                    @click="playInVideo(true)"
                  />
                  <i
                    v-if="isPlay"
                    class="mc-fa icon-outline_pause-circle"
                    @click="playInVideo(false)"
                  />
                </span>
              </div>
              <div>
                <span>
                  <i
                    v-if="!isMuted"
                    class="mc-fa icon-outline_volume-up"
                    @click="muteInVideo(true)"
                  />
                  <i
                    v-if="isMuted"
                    class="mc-fa icon-outline_volume-off"
                    @click="muteInVideo(false)"
                  />
                </span>
                <i v-if="!isFullScreen" class="mc-fa icon-outline_expand" @click="fullScreen" />
                <i v-else class="mc-fa icon-outline_collapse" @click="closeFullscreen" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="6" class="mc-modal__filter-footer-fav" />

          <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" class="me-3" @click="cancel()">
              {{ $t('global.action.close') }}
            </b-button>
            <template v-if="isSalesDemo">
              <button class="btn btn-primary" @click="downloadVideo">
                <i class="mc-fa icon-outline_download" /> {{ $t('global.action.download') }}
              </button>
            </template>
            <template v-else>
              <a :href="dataVideo.formattedAlertData" download class="btn btn-primary">
                <i class="mc-fa icon-outline_download" /> {{ $t('global.action.download') }}
              </a>
            </template>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      v-if="phaseOneShow"
      id="modal-call"
      ref="modal-call"
      class="mc-modal"
      :title="$t('notification.action.callDriver')"
      header-bg-variant="primary"
      header-close-variant="light"
      :ok-title="$t('global.action.register')"
      :cancel-title="$t('global.action.close')"
      cancel-variant="outline-primary"
      size="md"
      centered
    >
      <b-row align-h="center">
        <b-col>
          <b-form-group
            id="fieldset-1"
            :label="$t('notification.text.enterNumber')"
            label-for="noHP"
          >
            <b-input-group prepend="+62">
              <b-form-input id="noHP" trim :placeholder="`${$t('global.action.enterNumber')}...`" />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import 'multi-range-slider-vue/MultiRangeSliderBarOnly.css'
import DatePicker from 'vue2-datepicker'
import datePickerLang from '@/helpers/date-picker-lang'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import McRadioButton from '@/components/McRadioButton'
import { getGeolocation } from '@/services/api/geolocation'
import {
  GET_RAW_ALERTS_WITH_ADDRESS,
  UPSERT_RAW_ALERTS_ACTION,
} from '@/services/api/driverscore/score'
import VideoPlayer from '@/components/Video/VideoPlayer.vue'
import { mapGetters } from 'vuex'
import VideoPlayerMux from '@/components/Video/VideoPlayerMux.vue'
import { adas } from '../lib/alert-code'
import { dataDemoAdas } from '../lib/data-demo/adas'
import ModalFilter from '../components/ModalFilter.vue'
import McFilterSelect from '@/components/McFilterSelect'
import { GetAddressData } from '@/services/api/map'
import cloneDeep from 'lodash/cloneDeep'
import { GET_VEHICLE_STATUSES_LAST_RECEIVE } from '@/services/api/fleet'
import { GET_VEHICLE_VIDEOS_TV2 } from '@/services/api/videoHistory/videos'
import { SET_UPLOAD_MEDIA, UPDATE_FILELIST } from '@/services/api/onlineCommand'
moment.locale('id')
/**
 * Starter component
 */
export default {
  page: {
    title: 'ADAS',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    VideoPlayer,
    VideoPlayerMux,
    McButton,
    McButtonBack,
    McGrapqlTable,
    ModalFilter,
    McFilterSelect,
    McRadioButton,
  },
  mixins: [Helper],
  data() {
    return {
      activeFilters: {},
      filterModal: {},
      phaseOneShow: false,
      period: [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      pastDate: moment().subtract(6, 'months'),
      futureEnd: moment().add(6, 'months'),
      currentPastDate: moment().subtract(6, 'months'),
      currentFutureEnd: moment().add(6, 'months'),
      isMonth: true,
      detailNotification: {},
      addresses: {},
      dataVideo: {
        alert: {
          descriptionIdn: '',
          descriptionEng: '',
        },
      },
      modalVideoOpen: false,
      playerInOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],

        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      refsName: `videoInPlayerNotif`,
      isPlay: true,
      isMuted: false,
      isFullScreen: false,
      alertCodeActive: [],
      // This state to collect raw alert in pagination active
      // The format is { vehicleId, createdOn }
      rawAlertsStateActive: [],
      rerequestLoadingState: [],
      rerequestInProgress: [],
      rerequestFailed: [],
      rerequestSuccess: [],
      rerequestCheckDeviceOfflineState: [],
      intervalLongPollingInProgress: null,
      // for demo purpuse
      isLoadingDownload: false,
      videoUrl: null,
      fieldShow: JSON.parse(localStorage.getItem('adasNotifFields')),
      falseAlertForm: {},
      formOpen: false,
      falseAlertSubmit: true,
    }
  },
  computed: {
    title() {
      return 'ADAS'
    },
    query() {
      return {
        get: async (filter) => {
          return this.getData(filter)
        },
      }
    },
    alertsFilter() {
      return adas.filter((item) => (item.scope == null ? true : item.scope))
    },
    alerts() {
      const data = cloneDeep(this.alertsFilter)
      data.forEach((item) => {
        item.label = this.$t(item.label)
      })
      data.sort((a, b) => {
        let x = a.label.toLowerCase()
        let y = b.label.toLowerCase()
        if (x < y) {
          return -1
        }
        if (x > y) {
          return 1
        }
        return 0
      })
      return data
    },
    dataDemo() {
      return dataDemoAdas.map((data) => {
        return {
          ...data,
          address: '',
          createdOn: `${this.period[0]}T${data.createdOn.split('T')[1]}`,
        }
      })
    },
    isSalesDemo() {
      const email = this.$store.state.identity.whoami.email
      return (
        (email === 'sales-demo@vsms.co.id' ||
          window.location.host === 'sales-demo.mceasy.com' ||
          window.location.host === 'demo.mceasy.com') &&
        this.periodeRangesInLast7Days
      )
    },
    periodeRangesInLast7Days() {
      const startDate = moment(this.period?.[0], 'YYYY-MM-DD')
      const endDate = moment(this.period?.[1], 'YYYY-MM-DD')

      // Calculate the last 7 days range
      const today = moment().startOf('day')
      const last7DaysStart = today.clone().subtract(7, 'days')
      const last7DaysEnd = today.clone().subtract(1, 'days')

      // Check if the given date range overlaps with the last 7 days range
      const overlaps =
        startDate.isSameOrBefore(last7DaysEnd) && endDate.isSameOrAfter(last7DaysStart)

      // Get today's date
      return overlaps || startDate.isSame(today, 'day') || endDate.isSame(today, 'day')
    },
    datePickerLang() {
      return datePickerLang()
    },
    storedFields() {
      return this.fieldShow.column
    },
    fields() {
      if (this.fieldShow) {
        return this.storedFields
      } else {
        return [
          {
            key: 'alert',
            label: this.$t('notification.field.type'),
            isSortable: false,
            isLocked: true,
          },
          {
            key: 'createdOn',
            label: this.$t('global.field.date'),
            isSortable: false,
          },
          {
            key: 'vehicle',
            label: this.$t('global.object.licensePlate'),
            isSortable: false,
          },
          {
            key: 'driver.fullname',
            label: this.$t('global.object.driverName'),
            isSortable: false,
            formatter: (val) => {
              return val ?? '-'
            },
          },
          {
            key: 'geofence',
            label: this.$t('global.object.geolocation'),
            isSortable: false,
          },
          {
            key: 'address',
            label: this.$t('global.object.location'),
            isSortable: false,
            thClass: 'mc-table--250',
          },
          {
            key: 'falseAlert',
            isSortable: false,
            label: 'False Alert?',
            shown: false,
          },
          {
            key: 'falseAlertReason',
            isSortable: false,
            label: this.$t('notification.field.falseAlertReason'),
            shown: false,
          },
          {
            key: 'video',
            label: 'Media',
            sortable: false,
          },
        ]
      }
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isWhitelabel: 'identity/isWhitelabel',
    }),
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.last3Days'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 72)
            return [date, new Date()]
          },
        },
      ]
    },
    getStatusUpload() {
      if (!this.detailNotification?.createdOn) return null
      return this.getStatusVideo(this.detailNotification)
    },
    getFormatVideo() {
      if (this.dataVideo?.formattedAlertData) {
        const arrUrl = this.dataVideo.formattedAlertData.split('?')
        const arrFormat = arrUrl[0].split('.')
        const format = arrFormat[arrFormat.length - 1]
        return format.toLowerCase()
      } else {
        return 'mp4'
      }
    },
    falseAlertReasons() {
      return [
        {
          key: 'not-valid',
          label: this.$t('notification.text.notValid'),
          value: 'Tidak ada kejadian',
        },
        {
          key: 'wrong-detection',
          label: this.$t('notification.text.wrongDetection'),
          value: 'Terdeteksi sebagai kejadian lain',
        },
        {
          key: 'others',
          label: this.$t('notification.text.otherReasons'),
          value: 'Alasan Lainnya',
        },
      ]
    },
  },
  watch: {
    formOpen(newValue) {
      if (newValue && this.falseAlertForm.reason === 'others') {
        this.falseAlertForm.others = this.detailNotification?.falseAlert?.feedback || null
      }
    },
  },
  mounted() {
    this.handleChangeActiveFilters([
      { key: 'startDate', values: moment(`${this.period[0]} 00:00:00`).toISOString() },
      { key: 'endDate', values: moment(`${this.period[1]} 23:59:59`).toISOString() },
    ])

    this.intervalLongPollingInProgress = setInterval(() => {
      this.checkDownloadInProgress()
    }, 60 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.intervalLongPollingInProgress)
  },
  methods: {
    async getData(filter) {
      let filterDate = {}
      let filterAlerts = []
      let otherFilters = {}
      if (Object.keys(this.activeFilters).length > 0) {
        Object.keys(this.activeFilters).forEach((key) => {
          let filterValue = this.activeFilters[key]
          if (key === 'startDate') {
            filterDate[key] = filterValue
          } else if (key === 'endDate') {
            filterDate[key] = filterValue
          } else if (key === 'alertCode') {
            filterValue.map((item) => filterAlerts.push(Number(item)))
          } else if (key === 'isFalseAlert') {
            otherFilters[key] = filterValue ? true : undefined
          } else {
            otherFilters[key] = filterValue
          }
        })
      }

      const alertCode =
        filterAlerts.length !== 0
          ? { alertCode: filterAlerts }
          : { alertCode: this.alerts.flatMap((item) => item.alertCode) }
      this.alertCodeActive = alertCode.alertCode

      if (this.isSalesDemo) {
        const result = {
          data: this.dataDemo.filter((item) => alertCode.alertCode.includes(item.alertCode)),
          pagination: {
            page: 1,
            show: 10,
            total: this.dataDemo.filter((item) => alertCode.alertCode.includes(item.alertCode))
              .length,
          },
        }

        const tempAddresses = {}
        for (let i = 0; i < result.data.length; i++) {
          const data = result.data[i]
          const resAddress = await GetAddressData(data.latitude, data.longitude)
          tempAddresses[data.latitude + '&' + data.longitude] = resAddress.display_name
        }

        this.addresses = { ...tempAddresses }

        return result
      } else {
        const res = await this.$apollo.query({
          query: GET_RAW_ALERTS_WITH_ADDRESS,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              ...filter,
              ...alertCode,
              ...otherFilters,
              orderBy: JSON.stringify({ createdOn: 'desc' }),
              startDate: filterDate.startDate,
              endDate: filterDate.endDate,
            },
          },
        })

        this.fetchAddresses(res)

        this.rawAlertsStateActive = res.data.rawAlerts.rawAlerts.data.map((data) => ({
          vehicleId: data.vehicle.id,
          createdOn: data.createdOn,
        }))

        return res.data.rawAlerts.rawAlerts
      }
    },

    async getLastReceive(vehicleId) {
      const response = await this.$apollo.query({
        query: GET_VEHICLE_STATUSES_LAST_RECEIVE,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: [vehicleId],
            vehicleStatus: ['service', 'archived', 'repair'],
          },
        },
      })
      return response.data.vehicleStatuses.vehicleStatuses
    },

    async fetchAddresses(res) {
      const useCache = this.isUsingCache()
      const coords = []
      const tempAddresses = { ...this.addresses }

      res.data.rawAlerts.rawAlerts.data.forEach((item) => {
        const lat = Number(item.latitude)
        const lon = Number(item.longitude)
        if (tempAddresses[lat + '&' + lon] === undefined) coords.push({ lat, lon })
      })

      if (coords.length > 0) {
        if (useCache) {
          const addresses = await getGeolocation(coords)

          for (const [key, value] of addresses) {
            tempAddresses[key.replace(',', '&')] = value.name
          }
        } else {
          await Promise.all(
            coords.map(async (coord) => {
              const res = await GetAddressData(coord.lat, coord.lon)
              tempAddresses[res.lat + '&' + res.lon] = res.display_name
            })
          )
        }
      }

      this.addresses = tempAddresses
    },
    getAddress(data) {
      return this.addresses[data.item.latitude + '&' + data.item.longitude]
    },
    handleFilterModal(filters) {
      this.filterModal = {
        alertCode: this.findFilterValue(filters, 'alertCode') || [],
        vehicleId: this.findFilterValue(filters, 'vehicleId') || [],
        driverId: this.findFilterValue(filters, 'driverId') || [],
        period: [
          this.findFilterValue(filters, 'startDate'),
          this.findFilterValue(filters, 'endDate'),
        ],
        geolocationType: this.findFilterValue(filters, 'geofence')?.geofenceSelectionMode || 'All',
        geolocationId: this.findFilterValue(filters, 'geofence')?.geofenceId || [],
        isFalseAlert: this.findFilterValue(filters, 'isFalseAlert'),
      }
    },
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)
        if (filter.values === null || filter.values === undefined) return
        if (Array.isArray(filter.values) && filter.values.length === 0) return
        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
    hideModalVideo() {
      this.modalVideoOpen = false
      this.formOpen = false
      this.dataVideo = {}
      this.falseAlertForm = {}
      this.$bvModal.hide('modal-notification')
    },
    async openVideo(item) {
      const falseAlert = item.lastUserFeedback
      this.dataVideo = { ...item }
      if (falseAlert) {
        const selectedReason = this.falseAlertReasons.find(
          (item) => item.value === falseAlert.feedback
        )
        this.falseAlertForm.reason = selectedReason ? selectedReason.key : 'others'
        this.falseAlertForm.others = selectedReason ? null : falseAlert.feedback
      }
      if (this.isSuccessRequestVideo(item.vehicle.id, item.createdOn)) {
        this.dataVideo.formattedAlertData = this.getUrlSuccessRequestMedia(
          item.vehicle.id,
          item.createdOn
        )
      }

      this.playerInOptions.sources[0].src = this.isSuccessRequestVideo(
        item.vehicle.id,
        item.createdOn
      )
        ? this.getUrlSuccessRequestMedia(item.vehicle.id, item.createdOn)
        : item.formattedAlertData

      this.$bvModal.show('modal-video')
      this.modalVideoOpen = true
      if (this.isWhitelabel()) {
        this.changeThumbnailVideo()
      }
    },
    async openModalNotification(item) {
      const falseAlert = item.lastUserFeedback
      this.detailNotification = { ...item }
      if (falseAlert) {
        const selectedReason = this.falseAlertReasons.find(
          (item) => item.value === falseAlert.feedback
        )
        this.falseAlertForm.reason = selectedReason ? selectedReason.key : 'others'
        this.falseAlertForm.others = selectedReason ? null : falseAlert.feedback
      }
      this.detailNotification.address = this.addresses[item.latitude + '&' + item.longitude]
      this.$bvModal.show('modal-notification')
    },
    onClicked(item) {
      if (!this.hasAccessAll(['e1g-web-adas:read', 'alert_code:read', 'raw_alerts_driver:read'])) {
        return
      }
      localStorage.setItem('adas-detail-data', JSON.stringify(item))

      this.$router.push({
        name: 'Advanced Driver Assistance System Detail',
        params: { id: item.vehicle.id },
      })
    },
    onInPlayerReady() {
      this.$refs[this.refsName].player.play()
    },
    onInPlayerError(e) {
      // eslint-disable-next-line no-console
      console.log(e)
    },
    onInPlayerWaiting() {
      setTimeout(() => {
        this.$refs[this.refsName].player.pause()
      }, 20 * 1000)
    },
    onInPlayerLoadedData(e) {
      // eslint-disable-next-line no-console
      console.log(e)
    },
    onInPlayerEnded() {
      this.$refs[this.refsName].player.pause()
      this.isPlay = !this.isPlay
    },
    playInVideo(isPlay) {
      this.isPlay = !this.isPlay
      if (!isPlay) {
        this.$refs[this.refsName].player.pause()
        return
      }

      this.$refs[this.refsName].player.play()
    },
    muteInVideo(isMuted) {
      this.isMuted = !this.isMuted
      this.$refs[this.refsName].player.muted(isMuted)
    },
    fullScreen() {
      this.isFullScreen = true
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },
    closeFullscreen() {
      this.isFullScreen = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    },
    changeDate() {
      this.handleChangeActiveFilters([
        { key: 'startDate', values: moment(`${this.period[0]} 00:00:00`).toISOString() },
        { key: 'endDate', values: moment(`${this.period[1]} 23:59:59`).toISOString() },
      ])
    },
    disabledRange: function (date) {
      let limit = new Date()

      return (
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd ||
        date > limit
      )
    },
    pickDate(date) {
      const maxDate = 3
      this.currentPastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
        this.currentFutureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.currentFutureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    closePicker() {
      this.currentPastDate = moment().subtract(6, 'months')
      this.currentFutureEnd = moment().add(6, 'months')
    },
    closeCalendar() {
      this.closePicker()
      this.$refs.notifPeriodPicker.defaultOpen = false
    },
    downloadVideo() {
      this.downloadResource(this.dataVideo.formattedAlertData)
    },
    forceDownload(blob, filename) {
      let a = document.createElement('a')
      a.download = filename
      a.href = blob
      // For Firefox https://stackoverflow.com/a/32226068
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    // Current blob size limit is around 500MB for browsers
    downloadResource(url, filename) {
      if (!filename) filename = url.split('\\').pop().split('/').pop()
      this.isLoadingDownload = true
      this.videoUrl = url
      fetch(url, {
        headers: new Headers({
          Origin: location.origin,
        }),
        mode: 'cors',
      })
        .then((response) => response.blob())
        .then((blob) => {
          let blobUrl = window.URL.createObjectURL(blob)
          this.forceDownload(blobUrl, filename)
          this.isLoadingDownload = false
          this.videoUrl = null
        })
        // eslint-disable-next-line no-console
        .catch((e) => console.error(e))
    },
    changeThumbnailVideo() {
      const thumbnailWhitelabel = require('@/assets/images/thumbnailvideo-whitelabel.jpg')
      const root = document.querySelector(':root')
      root.style.setProperty('--thumbnail-video', `url('${thumbnailWhitelabel}')`)
    },
    handleApplyFilters(value) {
      const { period, geolocationType, geolocationId } = Object.fromEntries(
        value.map((item) => [item.key, item.values])
      )

      this.period = period

      const filters = value.filter(
        (item) => !['geolocationType', 'geolocationId', 'period'].includes(item.key)
      )

      filters.push(
        { key: 'startDate', values: moment(`${this.period[0]} 00:00:00`).toISOString() },
        { key: 'endDate', values: moment(`${this.period[1]} 23:59:59`).toISOString() }
      )

      if (geolocationType !== 'All') {
        filters.push({
          key: 'geofence',
          values: { geofenceId: geolocationId, geofenceSelectionMode: geolocationType },
        })
      } else {
        filters.push({
          key: 'geofence',
          values: null,
        })
      }

      this.handleFilterModal(filters)
      this.handleChangeActiveFilters(filters)
    },
    handleFieldShow(fields) {
      localStorage.setItem('adasNotifFields', JSON.stringify({ column: fields }))
    },
    isMoreThan3Days(createdOn) {
      return moment(createdOn).isBefore(moment().subtract(3, 'days'))
    },

    async checkFileListJcExist(vehicleId, alertCreatedOn) {
      const channel = 1
      const startTime = moment(alertCreatedOn).clone().subtract(60, 'seconds').toISOString()
      const endTime = moment(alertCreatedOn).clone().add(60, 'seconds').toISOString()
      const response = await this.$apollo.query({
        query: GET_VEHICLE_VIDEOS_TV2,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            channels: [channel],
            fileListOnly: true,
            isFromCache: false,
            vehicleId,
            startTime,
            endTime,
          },
        },
      })

      return response.data.vehicleVideos.vehicleVideos.files.length > 0 ? true : false
    },

    async requestVideo(imei, date, deviceType, vehicleId) {
      let startTime, endTime, rawAlertCreatedOn, fileListJcExist
      const payloadInput = {
        imei,
        useInMemoryDB: true,
      }
      if (deviceType === 'bsj') {
        startTime = moment(date).clone().subtract(5, 'seconds').toISOString()
        endTime = moment(date).clone().add(5, 'seconds').toISOString()
        payloadInput['bsjInput'] = { channel: 'CH01', startTime, endTime, createdOnRawAlert: date }
      } else if (deviceType === 'jc') {
        fileListJcExist = await this.checkFileListJcExist(vehicleId, date)

        if (!fileListJcExist) {
          this.rerequestLoadingState = this.rerequestLoadingState.filter(
            (state) => !(state.vehicleId === vehicleId && state.createdOn === date)
          )
          this.rerequestFailed.push({ vehicleId, createdOn: date })
          this.$mcToast.error(this.$t('notification.text.videoNotFound'))
          return
        }

        rawAlertCreatedOn = date
        payloadInput['rawAlertInput'] = {
          cameraPosition: 1,
          rawAlertCreatedOn,
        }
      }

      const response = await this.$apollo.mutate({
        mutation: SET_UPLOAD_MEDIA,
        variables: {
          input: payloadInput,
        },
      })
      this.rerequestLoadingState = this.rerequestLoadingState.filter(
        (state) => !(state.vehicleId === vehicleId && state.createdOn === date)
      )
      const responseMessage = response.data.setUploadMedia.setUploadMedia.message
      if (responseMessage === 'Sent') {
        this.rerequestInProgress.push({ vehicleId, createdOn: date })
      } else if (responseMessage === 'Not Sent(No video downloaded)') {
        this.rerequestFailed.push({ vehicleId, createdOn: date })
        this.$mcToast.error(this.$t('notification.text.videoNotFound'))
      }
    },

    async handleClickRequestVideo(data) {
      const isDeviceOffline = await this.checkDeviceOffline(data.vehicle.id, data.createdOn)
      if (isDeviceOffline) {
        this.$mcToast.error(this.$t('notification.text.deviceUnreachable'))
        return
      }
      this.rerequestLoadingState.push({ vehicleId: data.vehicle.id, createdOn: data.createdOn })

      const deviceType = this.getDeviceType(data.vehicle.device.deviceCode)
      const createdOn = data.createdOn

      this.requestUpdateFileList(deviceType, data.vehicle.imei, createdOn)
      await this.delay(5000)
      this.requestVideo(data.vehicle.imei, createdOn, deviceType, data.vehicle.id)
    },

    async requestUpdateFileList(deviceType, imei, createdOn) {
      let input = { imei, useInMemoryDB: true }
      if (deviceType === 'bsj' || deviceType === 'vss-howen') {
        const dateRange = this.getDefaultUpdateFileListAlertDateRange(createdOn)
        input['dateRange'] = {
          start: dateRange.start,
          end: dateRange.end,
        }
        input['channel'] = 1
        input['useInMemoryDB'] = true
      }
      await this.$apollo.mutate({
        mutation: UPDATE_FILELIST,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
    },

    isRequestInProgress(vehicleId, createdOn) {
      return this.rerequestInProgress.some(
        (state) => state.vehicleId === vehicleId && state.createdOn === createdOn
      )
    },

    isLoadingRequestVideo(vehicleId, createdOn) {
      return this.rerequestLoadingState.some(
        (state) => state.vehicleId === vehicleId && state.createdOn === createdOn
      )
    },

    isFailedRequestVideo(vehicleId, createdOn) {
      return this.rerequestFailed.some(
        (state) => state.vehicleId === vehicleId && state.createdOn === createdOn
      )
    },

    isSuccessRequestVideo(vehicleId, createdOn) {
      return this.rerequestSuccess.some(
        (state) => state.vehicleId === vehicleId && state.createdOn === createdOn
      )
    },

    isLoadingCheckDeviceOffline(vehicleId, createdOn) {
      return this.rerequestCheckDeviceOfflineState.some(
        (state) => state.vehicleId === vehicleId && state.createdOn === createdOn
      )
    },

    getUrlSuccessRequestMedia(vehicleId, createdOn) {
      return this.rerequestSuccess.find(
        (state) => state.vehicleId === vehicleId && state.createdOn === createdOn
      ).mediaUrl
    },

    async checkDeviceOffline(vehicleId, createdOn) {
      this.rerequestCheckDeviceOfflineState.push({
        vehicleId: vehicleId,
        createdOn: createdOn,
      })
      const response = await this.getLastReceive(vehicleId)
      const lastReceive = response[0].lastReceive
      this.rerequestCheckDeviceOfflineState = this.rerequestCheckDeviceOfflineState.filter(
        (state) => !(state.vehicleId === vehicleId && state.createdOn === createdOn)
      )

      const diffMinutes = this.getDurationBetween2Dates(lastReceive, this.now())
      return diffMinutes > 10 ? true : false
    },

    async checkDownloadInProgress() {
      if (this.rerequestInProgress.length === 0 || this.rawAlertsStateActive.length === 0) return
      const downloadInProgressActive = this.rawAlertsStateActive.filter((alert) => {
        return this.rerequestInProgress.some(
          (state) => state.vehicleId === alert.vehicleId && state.createdOn === alert.createdOn
        )
      })
      if (downloadInProgressActive.length === 0) return
      let createdOnList = downloadInProgressActive.map((data) => data.createdOn)
      createdOnList = createdOnList.map((time) => moment(time)).sort((a, b) => a - b)
      const startTime = createdOnList[0].subtract(1, 'seconds').toISOString()
      const endTime = createdOnList[createdOnList.length - 1].add(1, 'seconds').toISOString()

      const vehicleIds = []
      downloadInProgressActive.forEach((data) => {
        if (!vehicleIds.includes(data.vehicleId)) vehicleIds.push(data.vehicleId)
      })

      const response = await this.$apollo.query({
        query: GET_RAW_ALERTS_WITH_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            alertCode: this.alertCodeActive,
            orderBy: JSON.stringify({ createdOn: 'desc' }),
            startDate: startTime,
            endDate: endTime,
            vehicleId: vehicleIds,
          },
        },
      })

      const dataAlerts = response.data.rawAlerts.rawAlerts.data

      // Check status download
      for (let i = 0; i < dataAlerts.length; i++) {
        const alert = dataAlerts[i]
        const statusDownload = alert.additionalData?.downloadVideoStatus
        if (statusDownload === 'I' || !statusDownload) continue
        if (statusDownload === 'F' || statusDownload === 'S') {
          this.rerequestInProgress = this.rerequestInProgress.filter(
            (state) =>
              !(state.vehicleId === alert.vehicle.id && state.createdOn === alert.createdOn)
          )
        }
        if (statusDownload === 'F') {
          this.rerequestFailed.push({ vehicleId: alert.vehicle.id, createdOn: alert.createdOn })
        } else if (statusDownload === 'S') {
          this.rerequestSuccess.push({
            vehicleId: alert.vehicle.id,
            createdOn: alert.createdOn,
            mediaUrl: alert?.formattedAlertData,
          })
        }
      }
    },
    async saveFalseAlert(isFalseAlert) {
      if (
        isFalseAlert &&
        this.falseAlertForm.reason === 'others' &&
        !this.falseAlertForm.others.trim()
      ) {
        this.$mcToast.error(
          `${this.$t('notification.text.otherReasons')} ${this.$t('global.validation.required')}`
        )
        return
      }
      this.falseAlertSubmit = true
      const reasons = this.falseAlertReasons.find((item) => item.key === this.falseAlertForm.reason)
      const input = {
        selectionMode: 'Selection',
        actionType: 'FalseAlert',
        rawAlertId: this.modalVideoOpen
          ? [this.dataVideo.rawAlertId]
          : [this.detailNotification.rawAlertId],
        data: `${isFalseAlert}|${
          reasons.key !== 'others' ? reasons.value : this.falseAlertForm.others
        }`,
      }
      const res = await this.$apollo.mutate({
        mutation: UPSERT_RAW_ALERTS_ACTION,
        variables: {
          input,
        },
      })
      if (!res.data.upsertRawAlertsAction.isSuccessful) {
        this.$mcToast.error(res.data.upsertRawAlertsAction.message)
        this.falseAlertSubmit = false
        return
      }
      this.falseAlertForm = {}
      const upsertAlert = res.data.upsertRawAlertsAction.upsertRawAlertsAction
      const [isFalseAlertStr, feedbackText] = upsertAlert.data.split('|')
      const falseAlert = isFalseAlertStr === 'true'
      const lastUserFeedback = {
        createdOn: upsertAlert.createdOn,
        userId: upsertAlert.userId,
        feedback: feedbackText || '',
      }
      if (this.modalVideoOpen) {
        this.dataVideo = {
          ...this.dataVideo,
          lastUserFeedback: lastUserFeedback,
          isFalseAlert: falseAlert,
        }
      } else {
        this.detailNotification = {
          ...this.detailNotification,
          lastUserFeedback: lastUserFeedback,
          isFalseAlert: falseAlert,
        }
      }
      this.formOpen = false
      this.falseAlertSubmit = false
      if (falseAlert) {
        this.$mcToast.success(this.$t('notification.text.falseAlertSuccess'))
      } else {
        this.$mcToast.success(this.$t('notification.text.cancelFalseAlert'))
      }
    },
    closeModalNotification() {
      this.formOpen = false
      this.detailNotification = {}
      this.falseAlertForm = {}
    },
    openNotificationDetail(item) {
      const createdOn = new Date(item.createdOn).getTime()
      const id = `${item.alertCode}-${item.vehicle.id}-${createdOn}`

      this.$router.push({
        name: 'Notification Detail',
        params: {
          id: id,
          type: 'adas',
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.false-alert-icon {
  .mc-fa {
    &:before {
      color: $danger;
      font-size: 20px;
    }
  }
}
</style>
